import { CartButton } from "./cartButton"
import { DropdownButton } from "./dropdownButton"
import { HomeButton } from "./homeButton"
import { ProfileButton } from "./profileButton"
import styles from "./style.module.css"

export const ButtonsContainer = () => {

    return(

        <div className={styles.container}>
            <HomeButton />
            <CartButton/>
            <ProfileButton/>
            <DropdownButton/>
        </div>

    )

}